<template>
  <footer class="dashboard-main-footer" v-html="footerHtml" />
</template>

<script>
export default {
  name: "Navigation",

  data () {
    return {
      footerHtml: Dashboard.footerHtml
    };
  }
};
</script>
